import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetDomainFeatureStatuses as GetDomainFeatureStatusesQuery,
    GetDomainFeatureStatuses_domainFeatureStatuses as DomainFeatureStatus,
} from 'nutshell-graphql-types';

import GET_DOMAIN_FEATURE_STATUSES from '../queries/get-domain-feature-statuses.graphql';

export const useGetDomainFeatureStatuses = (): {
    domainFeatureStatuses: DomainFeatureStatus[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetDomainFeatureStatusesQuery,
        Record<any, any>
    >(GET_DOMAIN_FEATURE_STATUSES);

    const domainFeatureStatuses = data ? data.domainFeatureStatuses : [];

    return {
        domainFeatureStatuses,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
